import { color as colors } from 'styles/globals';
import type { ArticleSeriesListConfig } from 'interfaces/content/articles/Articles';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import {
  Header,
  ListWrapper,
  List,
  ListItemWrapper,
  BulletIcon,
  Link,
  Current,
  Position,
} from './ArticleSeriesListStyles';

const ArticleSeriesList = ({
  seriesID,
  series,
  className,
  currentArticleId,
  color = colors.recommendsGreen,
  dataCy,
}: ArticleSeriesListConfig) => {
  const seriesLength = series?.posts?.length || 0;
  if (seriesLength === 0) return null;
  return (
    <ListWrapper
      id={seriesID}
      className={className}
      data-cy={dataCy}
      $color={color}
    >
      <Header
        as='h4'
        $fontFamily='graphikCond'
        $size={{ default: 'level6', mdMin: 'level4' }}
      >
        {series.name}
      </Header>
      <List>
        {series?.posts?.map(({ id, title, uri }, idx) => {
          const currentPosition = idx + 1;
          const isCurrent = id === currentArticleId;
          return (
            <ListItemWrapper key={id}>
              <BulletIcon $isCurrent={isCurrent} />
              <Link
                type='primary'
                href={uri}
              >
                <h5>{title}</h5>
              </Link>
              {isCurrent && <Current aria-label='current article'>Currently on</Current>}
              <Position aria-label={`${currentPosition} out of ${seriesLength}`}>
                {`${currentPosition}/${seriesLength}`}
              </Position>
            </ListItemWrapper>
          );
        })}
      </List>
    </ListWrapper>
  );
};

export default withErrorBoundary(ArticleSeriesList, { fragment: UIFragments.ARTICLE_SERIES });
